module.exports = __webpack_public_path__ + "img/MSC_logo.17c3d692.png";